/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Empty_TitleInputs */

const vi_grower_area_camera_empty_title = /** @type {(inputs: Grower_Area_Camera_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vùng này chưa gắn camera`)
};

/**

* @param {Grower_Area_Camera_Empty_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_empty_title = /** @type {((inputs?: Grower_Area_Camera_Empty_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Empty_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_empty_title(inputs)
});